import { createStyle } from '@gluestack-style/react';

export const FormControlError = createStyle({
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  mt: '$1',
  gap: '$1',
});
